import React from 'react';
import propTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import Login from '../../container/profile/authentication/overview/SignIn';

const ProtectedRoute = ({ component, path }) => {
  const isLoggedIn = useSelector(state => state.auth.token);
  return isLoggedIn ? <Route component={component} path={path} /> : <Redirect to="/login" />;
};

ProtectedRoute.propTypes = {
  component: propTypes.object.isRequired,
  path: propTypes.string.isRequired,
};

export default ProtectedRoute;
